import React from 'react';
import fileExtension from 'file-extension';
import ProgressiveImage from 'react-progressive-image';
import styled from 'styled-components';
//
import GifVideo from 'components/gif-video-bg';
//
export default ({ image, ...rest }) => {
  if (!image || !image.url) {
    return null;
  }

  const { url } = image;

  if (fileExtension(url).replace(/\?.*$/g, '') === 'gif') {
    return <GifVideo url={url} />;
  }

  const src = url;

  return (
    <Wrap {...rest}>
      <ProgressiveImage src={src}>
        {(src, loading) => (
          <BGStyled
            style={{
              backgroundImage: `url(${src})`,
              opacity: loading ? 0 : 1,
              transition: loading
                ? 'opacity 420ms ease-in'
                : 'opacity 0 ease-in'
            }}
          />
        )}
      </ProgressiveImage>
    </Wrap>
  );
};
//
const Wrap = styled.div`
  bottom: 0;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
`;
const BGStyled = styled.div`
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;
